import { useEffect, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { useCustomReducer } from '../../../../../base/customHooks'
import IPSelectBox, { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import Table from '../../../../../components/Table'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { AddBrandNoticeApi } from '../services/addBrandNoticeApi'
import { IBrandNotice, IBrandNoticeRequest } from '../models/models'
import { UpdateBrandNoticeApi } from '../services/updateBrandNoticeApi'
import _ from 'lodash'
import IPButton from '../../../../../components/IPButton'
import IPCheckbox from '../../../../../components/IPCheckBox'
import IPInput from '../../../../../components/IPInput'
import InputCampaign from '../../../../../components/InputCampaign'
import Textarea from '../../../../../components/IPTextarea/IPTextarea'
import IPTextarea from '../../../../../components/IPTextarea/IPTextarea'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { IBrand } from '../../../components/models/models'
import { getBrandApi } from '../../../components/api'
import { start } from 'repl'
import { getDateByTimezoneOffset } from '../../../../../base/utils/dataHelper'

interface IBrandInformationState {
  selectedNotice?: IBrandNotice
  text: string,
  order: number,
  brandId: number,
  enabled: boolean,
  buttonName: string
  brandList?: IBrand[]
  selectedMarka?: ISelectOption | null
}

function AddOrUpdateBrandNotices(props: BaseComponentWithContextProps) {
  const getInitialState = (): IBrandInformationState => {
    return {
      text: '',
      order: 0,
      brandId: 0,
      enabled: true,
      buttonName: 'Ekle'
    }
  }

  const intialState = getInitialState()
  const navigate: any = useNavigate()
  const routeLocation = useLocation()
  const [state, setState] = useCustomReducer<IBrandInformationState>(intialState)

  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  const [startDate, setStartDate] = useState<any>(new Date())
  const [endDate, setEndDate] = useState<any>(new Date())
  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === "Start")
      setStartDate(data)
    else
      setEndDate(data)
  }

  useEffect(() => {
    getBrand()
  }, [])

  const getBrand = async () => {
    props.showLoading()
    const data: any[] = await getBrandApi()
    setState({ brandList: data })
    props.hideLoading()
  }

  useEffect(() => {
    if (routeLocation.state && state.brandList) {
      const data = _.clone((routeLocation.state as any)?.brandList)
      setState({
        selectedNotice: data,
        text: data.Description,
        order: data.OrderNo,
        enabled: data.Enable,
        brandId: state.brandList?.find(a => a.Id === data.BrandId)?.Id,
        selectedMarka: { label: state.brandList?.find(a => a.Id === data.BrandId)?.Name, value: Number(state.brandList?.find(a => a.Id === data.BrandId)?.Id) },
        buttonName: 'Güncelle'
      })

      const newStartDate = data.StartDate ? new Date(data.StartDate) : null;
      const newEndDate = data.EndDate ? new Date(data.EndDate) : null;

      setStartDate(newStartDate)
      setEndDate(newEndDate)

    }
  }, [state.brandList])

  const addBrandNotice = async () => {
    props.showLoading()
    const req: IBrandNoticeRequest = {
      Text: state.text,
      StartDate: getDateByTimezoneOffset(startDate),
      EndDate: getDateByTimezoneOffset(endDate),
      Order: state.order,
      BrandId: state.brandId,
      Enabled: state.enabled
    }
    try {
      const brandApi = new AddBrandNoticeApi({})
      const data = await brandApi.addBrand(req)
      if (data) {
        Swal.fire({
          icon: 'success',
          title: "Duyuru başarılı bir şekilde eklendi.",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
        navigate(`../admin/BrandPageOperation/BrandNotices/ListBrandNotices`)
      }
      props.hideLoading()
    }
    catch (err: any) {
      props.hideLoading()
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    }
  }

  const updateBrandNotice = async () => {
    props.showLoading()
    const req: IBrandNoticeRequest = {
      Id: state.selectedNotice?.Id,
      Text: state.text,
      StartDate: getDateByTimezoneOffset(startDate),
      EndDate: getDateByTimezoneOffset(endDate),
      Order: state.order,
      BrandId: state.brandId,
      Enabled: state.enabled
    }
    try {
      const brandApi = new UpdateBrandNoticeApi({})
      const data = await brandApi.updateBrand(req)
      if (data) {
        Swal.fire({
          icon: 'success',
          title: "Duyuru başarılı bir şekilde güncellendi.",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
        navigate(`../admin/BrandPageOperation/BrandNotices/ListBrandNotices`)
      }
      props.hideLoading()
    }
    catch (err: any) {
      props.hideLoading()
      Swal.fire({
        icon: 'error',
        title: err.description,
        showConfirmButton: true,
        allowOutsideClick: false,
      });
    }
  }


  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header'>
            <span className='h4'>
              <h5></h5>
            </span>
          </div>
          <div className='card-body'>
            <div className='col-lg-2'>
              <div className='buttonsuz'>
                <Link to='../admin/BrandPageOperation/BrandNotices/ListBrandNotices'>
                  <IPButton type='button' className='btn btn-primary' text='Listeye Dön' />
                </Link>
              </div>
            </div>
            <div className='row mt-5'>
              <div className='form-group col-md-2'>
                <label className='labeltext'>Sıra No</label>
                <IPInput
                  type='number'
                  name='Order'
                  id='Order'
                  value={state.order}
                  onChange={(e) => setState({ order: Number(e.target.value) })}
                />
              </div>
              <div className='form-group col-md-3'>
                <label className='labeltext'>Marka</label>
                <IPSelectBox
                  isClearable
                  id='Brand'
                  name='Brand'
                  options={
                    state.brandList &&
                    state.brandList.map(brand => {
                      return { label: brand.Name + " (" + brand.Id + ")", value: brand.Id }
                    })
                  }
                  onChangeSingle={option => {
                    if (option) {
                      setState({
                        brandId: Number(option.value),
                        selectedMarka: option
                      })
                    } else {
                      setState({
                        brandId: 0,
                        selectedMarka: null
                      })
                    }
                  }}
                  value={state.selectedMarka}
                />
              </div>
              <div className='form-group col-md-3 align-self-end'>
                <InputCampaign
                  type='datetime-local'
                  id='StartDate'
                  name='StartDate'
                  label={'Başlangıç Tarihi'}
                  value={toDateTimeLocal(startDate)}
                  onChange={e => getDate(e.target.value, "Start")}
                  isActive
                />
              </div>
              <div className='form-group col-md-3 align-self-end'>
                <InputCampaign
                  type='datetime-local'
                  id='EndDate'
                  name='EndDate'
                  label={'Bitiş Tarihi'}
                  value={toDateTimeLocal(endDate)}
                  onChange={e => getDate(e.target.value, "End")}
                  isActive
                />
              </div>
              <div className='form-group col-md-1 align-self-end'>
                <label className='p-switch switch-color-success d-flex'>
                  <label className='floagit t-left mr-4'>
                    Aktif
                  </label>
                  <IPCheckbox name='Enabled' onChange={() => setState({ enabled: !state.enabled })} checked={state.enabled} />
                </label>
              </div>
              <div className='row'>
                <div className='form-group col-md-12'>
                  <label className='labeltext'>Duyuru Metni</label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={state.text}
                    onReady={editor => {
                      // You can store the "editor" and use when it is needed.
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData()
                      setState({ text: data })
                    }}
                    onBlur={(event, editor) => { }}
                    onFocus={(event, editor) => { }}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-md-2 align-self-end'>
                  <IPButton type='button' className='btn btn-success' onClick={() => state.selectedNotice ? updateBrandNotice() : addBrandNotice()} text={state.buttonName} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(AddOrUpdateBrandNotices)
